export default {
  data() {
    return {
      isButtonInHeader: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/user-management/user-management.js